import { useAppDispatch } from "../hooks/useRedux"
import AuthService from '../api/auth'
import { getAuthenticatedUser, setAuthenticated } from "../store/authSlice"
import { useState } from "react"
import { Link } from "react-router-dom"
import { useNotification } from "../hooks/useNotification"
import logo from '../assets/mot-safe.png'

export default function Login() {
  const notification = useNotification()
  const dispatch = useAppDispatch()
  const [submitting, setSubmitting] = useState(false)
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [remember, setRemember] = useState(false)

  const login = async (e: React.SyntheticEvent) => {
    e.preventDefault()

    setSubmitting(true)
    try {
      await AuthService.login(email, password, remember)
      dispatch(setAuthenticated(true))
      dispatch(getAuthenticatedUser())
    } catch (error: any) {
      notification.showError(
        'Failed to Login',
        error?.response?.data?.errors?.email
      )
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            className="mx-auto w-auto"
            src={logo}
            alt="MOT SAFE"
          />
          <h2 className="mt-12 text-center text-2xl font-header font-bold text-gray-900">Sign in to your account</h2>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form className="space-y-6" onSubmit={login}>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-600">
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-400 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-secondary-500 focus:border-secondary-500 sm:text-sm"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-600">
                  Password
                </label>
                <div className="mt-1">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-400 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-secondary-500 focus:border-secondary-500 sm:text-sm"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <input
                    id="remember-me"
                    name="remember-me"
                    type="checkbox"
                    className="h-4 w-4 text-secondary-500 focus:ring-secondary-500 border-gray-400 rounded"
                    checked={remember}
                    onChange={e => setRemember(e.target.checked)}
                  />
                  <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-600">
                    Remember me
                  </label>
                </div>

                <div className="text-sm">
                  <Link to="/forgot-password" className="link">Forgot your password?</Link>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="btn btn--primary w-full justify-center"
                  disabled={submitting}
                >
                  Sign in
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
